import { Component, Input } from '@angular/core';
import { Observable, Subscription, } from 'rxjs';
import { AuditLogListService, } from 'src/app/core/services/audit-log-list.service';
import { AuditLogModel } from 'src/app/core/models/security/audit-log.model';
import { LoginEvent } from 'src/app/core/enums/login-event-enum';
import { BaseListComponent } from '../base-list/base-list.component';
import { Roles } from 'src/app/core/security/roles';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';

const enum SortBy {
  None = 0,
  DateAsc = 1,
  DateDesc = 2
}

@Component({
  selector: 'app-audit-log-list',
  templateUrl: './audit-log-list.component.html',
  styleUrls: ['./audit-log-list.component.scss']
})

export class AuditLogListComponent extends BaseListComponent{

  logEventOptions = [
    { value: undefined, selectedText: $localize`:@@:Select Status`, dropdownText: $localize`:@@:Select Status`, default: true },
    { value: LoginEvent.Login, selectedText: $localize`:@@:Login`, dropdownText: $localize`:@@:Login` },
    { value: LoginEvent.Logout, selectedText: $localize`:@@:Logout`, dropdownText: $localize`:@@:Logout` },
    { value: LoginEvent.LoginFailed, selectedText: $localize`:@@:Login Failed`, dropdownText: $localize`:@@:Login Failed` }
    ]

  protected override searchPlaceHolderText: string = $localize`:@@:Search for Finite State Machines by name`;

  sortBy: SortBy = SortBy.None

  securityPermissionCanReadLoginHistory: boolean = this.authMyFileService.isInRole(Roles.admin);

  // Table data
  override listItemsObservable!: Observable<AuditLogModel[]>;

  @Input() userName?: string; 

  constructor(
    protected auditLogService: AuditLogListService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override openModalService: OpenModalService,
    protected override authMyFileService: AuthMyfileService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }


  ngOnInit(): void {

    if(this.authMyFileService.currentUserContextValue?.loginType == LoginType.Client){
      this.auditLogService.userName = this.authMyFileService.currentUserContextValue?.userName; 
    }else{
      this.auditLogService.userName = this.userName;
    }

    this.listItemsObservable = this.auditLogService.resultItems$;
    this.total = this.auditLogService.total$;
    this.isLoading = this.auditLogService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.isLoadingVal = true;
      } else {
        this.isLoadingVal = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
    });
    this.unsubscribe.push(subscr2);
  }
  
  ngOnDestroy() {
    this.clearSearch(this.auditLogService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  formatResponse(value: string): string {
    if (value.startsWith("{")) {
      return "Login"
    } else {
      return "Login Failed"
    }
  }

  formatStyle(value: string) {
    if (value.startsWith("{")) {
      return 'coloredTextArea green';
    } else {
      return 'coloredTextArea red';
    }
  }

  auditLogStatusFilter(status: any) {
    this.auditLogService.event = status.value;
  }

  getHeadersBrowser(request: any) {
    request = this.convertObjToMap(request)
    var browser = "";
    if (request.get('sec-ch-ua')) {
      browser = request.get('sec-ch-ua');
      if (browser.includes("Google Chrome")) {
        browser = "Google Chrome"
      }else if (browser.includes("Brave")) {
        browser = "Brave"
      }else{
        browser = request.get('sec-ch-ua').split(';')[0]
      }
    }else  if (request.get('User-Agent')) {
      browser = request.get('User-Agent');
      if (browser.includes("Firefox")) {
        browser = "Firefox"
      }else if (browser.includes("Safari")) {
        browser = "Safari"
      }else{
        browser = ""
      }
    }
    return browser;
  }

  getHeadersBrowserIcon(request: any) {
    request = this.convertObjToMap(request)
    var browser = "";
    if (request.get('sec-ch-ua')) {
      browser = request.get('sec-ch-ua');
      if (browser.includes("Google Chrome")) {
        browser = "ri-chrome-line"
      }else if (browser.includes("Brave")) {
        browser = ""
      }else{
        browser = ""
      }
    }else  if (request.get('User-Agent')) {
      browser = request.get('User-Agent');
      if (browser.includes("Firefox")) {
        browser = "ri-firefox-fill"
      }else if (browser.includes("Safari")) {
        browser = "ri-safari-line"
      }else{
        browser = ""
      }
    }
    return browser;
  }

  getHeadersDevice(request: any) {
    request = this.convertObjToMap(request)
    var device = "";

    if (request.get('User-Agent')) {
      device = request.get('User-Agent');
      if (device.includes("iPhone")) {
        device = "iPhone"
      }else if (device.includes("Android")) {
        device = "Android"
      }else if (device.includes("Macintosh")) {
        device = "Macintosh"
      }else if (device.includes("Windows")) {
        device = "Windows"
      }else if (device.includes("Linux")) {
        device = "Linux"
      }else{
        device = request.get('User-Agent').split('(')[1].split(')')[0]
      }
    }
    return device;
  }

  convertObjToMap(obj: any) {
    obj = Object.keys(obj).map(key => ({
      name: key,
      value: obj[key]
    }));
    let map = new Map<string, string>();

    obj.forEach((pair: any) => {
      map.set(pair.name, pair.value);
    })

    return map;
  }

  dateCovert(date: string) {
    var convertedDate = new Date(date)
    var month: any = convertedDate.getMonth() +1;
    if(month <10){
      month = `0${month}`
    }
    var time = convertedDate.toLocaleString('en-US', { hour: 'numeric', hour12: true, minute: '2-digit' })
    return `${convertedDate.getDate()}-${month}-${convertedDate.getFullYear()} at ${time}`;
  }


  sort(passedSortBy: SortBy) {
    this.sortBy = passedSortBy;
    switch (passedSortBy) {
      case 1:
        this.serviceSort(this.auditLogService, 'createdDate', "asc");
        break;
      case 2:
        this.serviceSort(this.auditLogService,'createdDate', "desc");
        break;

      default:
        this.serviceSort(this.auditLogService,'', '');
        break;
    }
  }

}





